<template>
  <c-container>
    <c-checkout-progress />

    <c-ticket-container>
      <template #default>
        <c-visitor-info>
          <template #title>
            {{ getLabel('introduction.tours_head') }}
          </template>

          <template #introduction>
            <div
              class="visitor-info__introduction"
              v-html="getLabel('introduction.tours')"
            />
          </template>

          <template #introduction-tickets>
            <div v-html="getLabel('introduction.tours_ticket')" />
          </template>
        </c-visitor-info>

        <c-tours />
      </template>

      <template #banner>
        <c-button-group align="center">
          <c-action-link
            :router-link="$t('backToBooking.link')"
            exact
          >
            <c-icon
              type="chevron-left"
              :size="0.75"
            />
            {{ $t('backToBooking.text') }}
          </c-action-link>

          <c-action-link
            v-if="cartValidation.valid"
            :router-link="$t('completeBooking.link')"
          >
            <span v-html="$t('completeBooking.text')" />
            <c-icon
              type="chevron-right"
              :size="0.75"
            />
          </c-action-link>
        </c-button-group>
      </template>
    </c-ticket-container>
  </c-container>
</template>

<script>
import CActionLink from '../components/actionLink.vue'
import CButtonGroup from '../components/buttonGroup.vue'
import CCheckoutProgress from '../components/checkoutProgress.vue'
import CContainer from '../components/container.vue'
import CIcon from '../components/icon.vue'
import CTicketContainer from '../components/CTicketContainer.vue'
import CTours from '../components/CTours.vue'
import CVisitorInfo from '../components/visitorInfo.vue'

import dateHelper from '../functions/dateHelper.js'

import cartValidationMixin from '../mixins/cartValidation.js'
import labelMixin from '../mixins/label.js'

export default {
  name: 'VBookingTours',

  components: {
    CActionLink,
    CButtonGroup,
    CCheckoutProgress,
    CContainer,
    CIcon,
    CTicketContainer,
    CTours,
    CVisitorInfo
  },

  mixins: [cartValidationMixin, labelMixin],

  computed: {
    cartLoading () {
      return this.$store.state.cartLoading
    }
  },

  created () {
    if (!this.$store.state.ticketSelection.selectedDate) {
      const currentDate = dateHelper.formatDate(dateHelper.getDate())
      this.$store.commit('setSelectedDate', currentDate)
    }
  }
}
</script>

<i18n locale="en">
{
  "backToBooking": {
    "text": "Change order",
    "link": "/booking"
  },
  "completeBooking": {
    "text": "Book now",
    "link": "/booking/overview"
  }
}
</i18n>

<i18n locale="de">
{
  "backToBooking": {
    "text": "Bestellung ändern",
    "link": "/buchung"
  },
  "completeBooking": {
    "text": "Jetzt buchen",
    "link": "/buchung/uebersicht"
  }
}
</i18n>
